import { AuthRoute } from '@/system-modules/auth/v1/api/AuthRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { ILoginRequest } from '@/contracts/system-modules/auth/dto/login-request/ILoginRequest'

export class LoginRequestsRoute extends AuthRoute<null, ILoginRequest[]> {
  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/system/v1/auth/login-requests'
  }

  offline(): Promise<ApiResponse<ILoginRequest[]>> {
    return Promise.resolve(new ApiResponse({ success: true, data: [] }))
  }
}
